var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "general-strategy" }, [
    !_vm.dataloaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c("div", [
          _c("div", { staticClass: "flex-row" }, [
            _c(
              "div",
              {
                staticClass: "flex-col flex-3 pr-1",
                attrs: { id: "generalStrategyCommentValue" },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.genStat.generalStrategyCommentValue) + " "
                ),
              ]
            ),
            _c("div", { staticClass: "flex-col flex-1 flex-align-center" }, [
              _c("div", { staticClass: "flex-row flex-5 boxborder" }, [
                _c("div", { staticClass: "flex-col" }, [
                  _c("div", { staticClass: "flex-row flex-1" }, [
                    _vm._v(_vm._s(_vm.$t("nextDecision")) + ":"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flex-row flex-4",
                      attrs: { id: "nextDecisionValue" },
                    },
                    [_vm._v(" " + _vm._s(_vm.genStat.nextDecisionValue) + " ")]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex-row component-header" }, [
                _vm._v(_vm._s(_vm.$t("prRecomendations"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-row pr-recommendation-value",
                  attrs: { id: "prRecommendationValue" },
                },
                _vm._l(_vm.recommendations, function (recommendation, index) {
                  return _c(
                    "span",
                    {
                      key: recommendation.name,
                      staticStyle: { whitespace: "nowrap" },
                    },
                    [
                      _c("span", { staticClass: "tooltip" }, [
                        _c("span", { staticClass: "tooltiptext" }, [
                          _c("dt", [_vm._v(_vm._s(recommendation.name))]),
                          _c("br"),
                          _c("dt", [_vm._v("Description: ")]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                recommendation.description ||
                                  _vm.$t(
                                    "recommendationDescriptionNotAvailable"
                                  )
                              )
                            ),
                          ]),
                          _c("br"),
                          _c("dt", [_vm._v("Rationale: ")]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                recommendation.rationale ||
                                  _vm.$t("recommendationRationaleNotAvailable")
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "tooltip__text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                index
                                  ? " " + recommendation.name
                                  : recommendation.name
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }